import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { NavLink, Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setAdminMode } from '../../store/slices/businessSlice';
import logo from '../../assets/logo_green_tm.png';
// eslint-disable-next-line no-unused-vars
import adminlogo from '../../assets/img/admin.png';
import userlogo from '../../assets/img/non_admin.png';
import Logout from '../Header/Logout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTachometerAlt, faUsers, faBuilding, faFileSignature, faListUl, faPuzzlePiece, faCreditCard, faChartLine, faCog, faHistory, faBars, faTimes, faEnvelopeOpenText, faLink, faComments, faDatabase } from '@fortawesome/free-solid-svg-icons';
import './AdminLayout.css';

function AdminLayout({
  currentUser,
  adminMode,
  setAdminMode,
  children
}) {
  const {
    t
  } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const menuItems = [{
    name: 'Dashboard',
    path: '/admin',
    icon: faTachometerAlt,
    exact: true
  }, {
    name: 'Users',
    path: '/admin/users',
    icon: faUsers
  }, {
    name: 'Businesses',
    path: '/admin/business',
    icon: faBuilding
  }, {
    name: 'Connections',
    path: '/admin/connections',
    icon: faLink
  }, {
    name: 'Invitations',
    path: '/admin/invitations',
    icon: faEnvelopeOpenText
  }, {
    name: 'Messages',
    path: '/admin/messages',
    icon: faComments
  }, {
    name: 'Subscriptions',
    path: '/admin/subscriptions',
    icon: faFileSignature
  }, {
    name: 'Plans & Features',
    path: '/admin/plans-features',
    icon: faListUl
  }, {
    name: 'Add-ons',
    path: '/admin/plans-features?tab=addons',
    icon: faPuzzlePiece,
    isActive: (match, location) => location.pathname === '/admin/plans-features' && location.search.includes('tab=addons')
  }, {
    name: 'Payments',
    path: '/admin/payments',
    icon: faCreditCard
  }, {
    name: 'Reports',
    path: '/admin/reports',
    icon: faChartLine
  }, {
    name: 'Settings',
    path: '/admin/settings/invites',
    icon: faCog
  }, {
    name: 'Audit Logs',
    path: '/admin/audit',
    icon: faHistory
  }, {
    name: 'Database',
    path: '/admin/database',
    icon: faDatabase
  }];
  return <div className="admin-container">
      {
      /* Mobile Top Bar */
    }
      <div className="admin-mobile-header d-flex d-md-none justify-content-between align-items-center p-3">
        <Link to="/"><img src={logo} alt={t("HeresMyInfo")} height="30" /></Link>
        <button className="mobile-toggle-btn btn btn-link p-0 text-white" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={sidebarOpen ? faTimes : faBars} size="lg" />
        </button>
      </div>

      <div className="d-flex min-vh-100">
        {
        /* Sidebar */
      }
        <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="sidebar-brand d-none d-md-block">
            <Link to="/"><img src={logo} alt={t("HeresMyInfo")} className="w-100" style={{
              maxHeight: '40px',
              objectFit: 'contain'
            }} /></Link>
          </div>

          {
          /* User Info Section */
        }
          {currentUser && <div className="sidebar-user-profile d-flex align-items-center px-3 py-3 border-bottom" style={{
          borderColor: 'rgba(255, 255, 255, 0.08)'
        }}>
              <div className="user-avatar-circle d-flex align-items-center justify-content-center mr-2">
                {((currentUser.firstName?.[0] || '') + (currentUser.lastName?.[0] || ''))?.toUpperCase() || currentUser.email?.[0]?.toUpperCase() || currentUser.username?.[0]?.toUpperCase() || 'A'}
              </div>
              <div className="user-text-details" style={{
            overflow: 'hidden',
            minWidth: 0
          }}>
                <div className="user-name text-white font-weight-bold text-truncate" style={{
              fontSize: '0.85rem',
              lineHeight: '1.2'
            }}>
                  {`${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim() || currentUser.username || 'Admin User'}
                </div>
                <div className="user-email text-muted text-truncate" style={{
              fontSize: '0.7rem',
              marginTop: '2px',
              lineHeight: '1.2'
            }}>
                  {currentUser.email}
                </div>
              </div>
            </div>}

          <div className="admin-badge-container">
            <span className="admin-badge">{t("SYSTEM ADMIN")}</span>
          </div>

          <nav className="sidebar-nav flex-grow-1">
            <ul className="list-unstyled p-0 m-0">
              {menuItems.map((item, idx) => <li key={idx} className="nav-item-wrapper">
                  <NavLink to={item.path} exact={item.exact} isActive={item.isActive} className="sidebar-link" activeClassName="active" onClick={() => setSidebarOpen(false)}>
                    <span className="icon-span">
                      <FontAwesomeIcon icon={item.icon} />
                    </span>
                    <span className="text-span">{item.name}</span>
                  </NavLink>
                </li>)}
            </ul>
          </nav>

          <div className="sidebar-footer">
            <Logout />
          </div>
        </aside>

        {
        /* Main Content Area */
      }
        <main className="admin-main-content flex-grow-1 p-3 p-md-4">
          <div className="admin-breadcrumb-bar d-none d-md-flex align-items-center justify-content-between mb-4">
            <div className="admin-indicator">
              <span className="admin-icon" role="img" aria-label="settings">⚙️</span>
              <span className="admin-label">{t("HeresMyInfo Administration Console")}</span>
            </div>
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px'
          }}>
              <Link to="/" className='admin-link' onClick={() => setAdminMode(false)}>
                <img src={userlogo} title={t("user mode")} alt={t("user mode")} className='adminLogo' style={{
                height: '35px',
                cursor: 'pointer'
              }} />
              </Link>
              <Link to="/" className="btn btn-sm btn-outline-success">{t("View Live Site")}</Link>
            </div>
          </div>
          {children}
        </main>
      </div>
    </div>;
}

const mapStateToProps = state => ({
  currentUser: state.auth.currentUser,
  adminMode: state.business?.adminMode || false
});

const mapDispatchToProps = {
  setAdminMode
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminLayout));